/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  "'Goals.CreateGoal.footer.create-label": '作成',
  'Goals.CreateGoal.create.error': 'ゴールを作成できませんでした',
  'Goals.CreateGoal.create.network.error': '接続に失敗しました',
  'Goals.CreateGoal.create.permission.error': 'ゴールの作成に必要な権限がありません。',
  'Goals.CreateGoal.error.description': '問題が発生しました。インターネット接続を確認してもう一度お試しください。',
  'Goals.CreateGoal.error.header': 'ゴールを作成できませんでした',
  'Goals.CreateGoal.footer.cancel-label': 'キャンセル',
  'Goals.CreateGoal.form.icon.back-button-label': '戻る',
  'Goals.CreateGoal.form.name.error': 'ゴール名を入力する必要があります',
  'Goals.CreateGoal.form.name.label': '名前',
  'Goals.CreateGoal.form.owner.error': '所有者は空白にできません。',
  'Goals.CreateGoal.header': 'ゴールを作成',
  'Goals.CreateGoal.parent-goal-label': '親ゴール',
  'Goals.CreateGoal.parent-goal.error': '親ゴールは空白にできません。',
  'Goals.CreateGoal.required-fields-are-marked': '必須フィールドにはアスタリスクが付いています<asterisk></asterisk>',
  'Goals.CreateGoal.site-label': 'サイト',
  'Goals.CreateGoal.type-label': 'タイプ',
  'Goals.CreateGoal.type-label-placeholder': '目標のタイトルを入力してください',
  'Goals.GoalCreationModal.label.date-selection-placeholder': '日付を選択',
  'Goals.GoalCreationModal.label.date-selection-title': '期日',
  'Goals.GoalCreationModal.label.owner-picker-placeholder': 'ユーザーを入力',
  'Goals.GoalCreationModal.label.owner-selection-title': '所有者',
  'townsquare.api.goal-type-description.goal': '汎用のゴール',
  'townsquare.api.goal-type-description.key-result': '目標を定量的に測定する方法 (OKR フレームワーク)。',
  'townsquare.api.goal-type-description.objective': '達成したい成果 (OKR フレームワーク)。',
};
